import { Component, ContentChild, ContentChildren, ElementRef, Input, QueryList, TemplateRef, ViewChild } from '@angular/core';
import { BaseViewComponent, ButtonRole, SubmissionBarKind } from '@sb/library/base';
import { ButtonComponent } from '@sb/library/button';

@Component({
    selector: 'lib-submission-bar',
    templateUrl: './submission-bar.component.html',
    styleUrl: './submission-bar.component.scss'
})
export class SubmissionBarComponent extends BaseViewComponent {
    @ContentChildren(ButtonComponent) buttonList!: QueryList<ButtonComponent>;
    @ContentChild('customAction') customActionRef: TemplateRef<any> | undefined;

    @ViewChild('newPrimaryButton') newPrimaryButton!: ButtonComponent;
    @ViewChild('newSecondaryButton') newSecondaryButton!: ButtonComponent;
    @ViewChild('newTertiaryButton') newTertiaryButton!: ButtonComponent;

    @Input({ required: true }) kind!: SubmissionBarKind;

    private _primaryButton: ButtonComponent | null = null;
    private _secondaryButton: ButtonComponent | null = null;
    private _tertiaryButton: ButtonComponent | null = null;

    ngAfterViewInit(): void {
        this.UpdateButtonReferences(this.buttonList.toArray());
        this.buttonList.changes.subscribe((buttonsQueryList: QueryList<ButtonComponent>) => {
            this.UpdateButtonReferences(buttonsQueryList.toArray());
        });
    }

    private UpdateButtonReferences(buttons: ButtonComponent[]) {
        this._primaryButton = buttons.find(button => button.role === ButtonRole.Primary) ?? null;
        this._secondaryButton = buttons.find(button => button.role === ButtonRole.Secondary) ?? null;
        this._tertiaryButton = buttons.find(button => button.role === ButtonRole.Tertiary) ?? null;

        // Override the button so that low-level events work
        setTimeout(() => {
            if (this._primaryButton && this.newPrimaryButton) {
                this._primaryButton.button = this.newPrimaryButton.button;
            }
            if (this._secondaryButton && this.newSecondaryButton) {
                this._secondaryButton.button = this.newSecondaryButton.button;
            }
            if (this._tertiaryButton && this.newTertiaryButton) {
                this._tertiaryButton.button = this.newTertiaryButton.button;
            }
        });
    }

    get primaryButton(): ButtonComponent | null {
        return this._primaryButton;
    }

    get secondaryButton(): ButtonComponent | null {
        return this._secondaryButton;
    }

    get tertiaryButton(): ButtonComponent | null {
        return this._tertiaryButton;
    }
}
